<div
  *ngIf="show && alert"
  class="fixed z-[1100] transition-all duration-500 animate-fade-in-out w-[calc(100%-48px)] left-6 md:w-auto md:left-auto md:right-8"
  [ngStyle]="{ top: alert.marginTop + 'px' }"
>
  <ui-alert
    [icon]="getIconName(alert.type)"
    [type]="alert.type"
    class="progresol"
    font-weight="semibold"
    text-type="p12"
    text-mobile-type="p12"
    [message]="alert.message"
  ></ui-alert>
</div>
